import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { isPendingAction, isRejectedAction, isFullfieldAction } from './slice.helper';
import Api from '../../services/stock-diamant-fb.service';



export const getNextMvmDiaFbNum = createAsyncThunk(
    "StockDiamantFb/getNextMvmFbNum",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.getNextMvmFbNum(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const createMvmDiaFb = createAsyncThunk(
    "StockDiamantFb/createMvmDiaFb",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.createMvmDiaFb(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const retourMvmDiaFb = createAsyncThunk(
    "StockDiamantFb/retourMvmDiaFb",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.retourMvmDiaFb(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const receiveMvmDiaFb = createAsyncThunk(
    "StockDiamantFb/receiveMvmDiaFb",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.receiveMvmDiaFb(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const receiveMvmDiaByFrn = createAsyncThunk(
    "StockDiamantFb/receiveMvmDiaByFrn",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.receiveMvmDiaByFrn(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const cancelMvmDiaFb = createAsyncThunk(
    "StockDiamantFb/cancelMvmDiaFb",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.cancelMvmDiaFb(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const listMvmDiaFb = createAsyncThunk(
    "StockDiamantFb/listMvmDiaFb",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.listMvmDiaFb(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const listMvmDiaByFrn = createAsyncThunk(
    "StockDiamantFb/listMvmDiaByFrn",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.listMvmDiaByFrn(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const viewMvmDiaFb = createAsyncThunk(
    "StockDiamantFb/viewMvmDiaFb",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.viewMvmDiaFb(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)
export const viewMvmDiaByFrn = createAsyncThunk(
    "StockDiamantFb/viewMvmDiaByFrn",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.viewMvmDiaByFrn(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const filterStockDiaFb = createAsyncThunk(
    "StockDiamantFb/filterStockDiaFb",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.filterStockDiaFb(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const checkArrivagePierre = createAsyncThunk(
    "StockDiamantFb/checkArrivagePierre",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.checkArrivagePierre(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)
export const checkRevoirArrivagePierre = createAsyncThunk(
    "StockDiamantFb/checkRevoirArrivagePierre",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.checkRevoirArrivagePierre(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const checkCommandePierre = createAsyncThunk(
    "StockDiamantFb/checkCommandePierre",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.checkCommandePierre(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const updateArrivagePierre = createAsyncThunk(
    "StockDiamantFb/updateArrivagePierre",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.updateArrivagePierre(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)
export const updateRevoirArrivagePierre = createAsyncThunk(
    "StockDiamantFb/updateRevoirArrivagePierre",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.updateRevoirArrivagePierre(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const viewStockDiaFb = createAsyncThunk(
    "StockDiamantFb/viewStockDiaFb",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.viewStockDiaFb(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)



const initialState = {
    loading: false,
    error: '',
    sel_StockDiamant: null
}

const StockDiamantFbSlice = createSlice({
    name: "StockDiamantFb",
    initialState: initialState,
    reducers: {
        clear: (state) => {
            Object.assign(state, initialState)
        },

    },
    extraReducers: builder => {
        builder
            .addMatcher(isFullfieldAction, (state, action) => {
                state[action.meta.requestId] = 'fulfilled'
                state.loading = false;
                state.error = '';
            })
            .addMatcher(isPendingAction, (state, action) => {
                state[action.meta.requestId] = 'pending'
                state.loading = true;
                state.error = '';
            })
            .addMatcher(isRejectedAction, (state, action) => {
                state[action.meta.requestId] = 'rejected'
                state.loading = false;
                state.error = action.payload;
            })



    }
})

const { reducer } = StockDiamantFbSlice;
export const { clear } = StockDiamantFbSlice.actions;
export default reducer;